module.exports = __webpack_public_path__ + "img/ddzyb_1920337.5@1x-tuya.97c57dab.png";